module.exports = __webpack_public_path__ + "img/banner04_01.d387dbbc.png";